import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "../data/mock";

export const FAQ = () => {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 lg:py-32 bg-ivory scroll-mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5 lg:sticky lg:top-32 lg:self-start">
          <div className="flex items-center gap-3 mb-6">
            <div className="gold-line" />
            <span className="text-xs tracking-[0.3em] uppercase text-navy/70 font-medium">
              Questions & Answers
            </span>
          </div>
          <h2
            data-testid="faq-headline"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl text-navy leading-[1.05] tracking-tight"
          >
            Asked
            <br />
            <span className="italic text-gold">often.</span>
            <br />
            Answered
            <br />
            plainly.
          </h2>
          <p className="mt-8 text-base lg:text-lg text-navy/75 leading-relaxed max-w-md">
            The questions clients, trustees and other attorneys ask before they
            pick up the phone. If yours isn't here, call (214) 415-1759.
          </p>
        </div>

        <div className="lg:col-span-7">
          {/* Itemscope FAQPage for AI/search crawlers */}
          <div
            itemScope
            itemType="https://schema.org/FAQPage"
            className="divide-y divide-[#C0974E]/20 border-y border-[#C0974E]/20"
          >
            {FAQS.map((faq, idx) => {
              const isOpen = openIdx === idx;
              return (
                <div
                  key={idx}
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  data-testid={`faq-item-${idx}`}
                  className="group"
                >
                  <button
                    onClick={() => setOpenIdx(isOpen ? -1 : idx)}
                    data-testid={`faq-toggle-${idx}`}
                    className="w-full text-left flex items-start justify-between gap-6 py-6 lg:py-7 hover:text-gold transition-colors cursor-pointer"
                    aria-expanded={isOpen}
                  >
                    <h3
                      itemProp="name"
                      data-speakable="true"
                      className="font-serif text-xl lg:text-2xl text-navy leading-snug pr-4 group-hover:text-navy"
                    >
                      {faq.q}
                    </h3>
                    <span className="flex-shrink-0 w-8 h-8 rounded-sm bg-navy/5 flex items-center justify-center text-navy mt-1 group-hover:bg-navy group-hover:text-gold transition-all">
                      {isOpen ? (
                        <Minus className="w-4 h-4" strokeWidth={2} />
                      ) : (
                        <Plus className="w-4 h-4" strokeWidth={2} />
                      )}
                    </span>
                  </button>
                  <div
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                    className={`overflow-hidden transition-all duration-500 ease-out ${
                      isOpen ? "max-h-[800px] opacity-100" : "max-h-0 opacity-0"
                    }`}
                  >
                    <p
                      itemProp="text"
                      data-speakable="true"
                      className="text-base lg:text-lg text-navy/80 leading-relaxed pb-6 lg:pb-7 pr-12 font-serif"
                    >
                      {faq.a}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
